import Model from "@/lib/model/model";
import request from "@/lib/request/request";
//这是牛人星球 自己端用的

export class NRparam extends Model {
  connectCode = "";
  nrxqToken = "";
  atsUserToken = "";
}

export default class NR extends Model {
  //检查状态
  static checkToken(param: NRparam) {
    return request.post("aiExam/nrxq/connect", param).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  //获取报告秘钥
  static getSid(param: any) {
    return request.post("aiExam/candidate/getSid", param).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
}
export class CodeForm extends Model {
  phone = "";
}
export class LoginFrom extends Model {
  phone = "";
  captcha = "";
  connectCode = "";
}

export class Login extends Model {
  nrxqToken = "";
  nrxqLoginStatus = "";

  static getCode(codeForm: CodeForm) {
    return request.post("aiExam/nrxq/sendCaptcha", codeForm);
  }

  static login(from: LoginFrom) {
    return request.post("aiExam/nrxq/login", from).then(resp => {
      return new Login().assign(resp.data.data);
    });
  }
}

export class InfoForm extends Model {
  nrxqToken = "";
  name = "";
  companyName = "";
  connectCode = "";
}

export class Info extends Model {
  static set(from: InfoForm) {
    return request.post("aiExam/nrxq/saveContent", from).then(resp => {
      return resp.data.data;
    });
  }
}
